import { Dropdown } from "bootstrap";
import dashboardService from "@/services/dashboardService";
import notificationService from "@/services/notificationService";
import * as vendorEvaluationService from "@/services/vendorEvaluationService";
import { getUserLogin, logout as performLogout } from "@/utils/auth";
import api from "@/services/api";

export default {
  name: "HeaderComponent",

  data() {
    const userLogin = getUserLogin() || {};

    return {
      username: userLogin?.mst_employee_name || "Administrator",
      email: userLogin?.mst_employee_email || userLogin?.email || "",
      nik: userLogin?.mst_employee_nik || "",
      userLogin: userLogin,

      expiringList: [],
      evalNotifications: [], // gabungan: t107 + pending approval
      unreadEvalCount: 0,

      showBackdrop: false,
      dropdownInstance: null,
      autoCloseTimer: null,
      notifInterval: null,
      isLoadingNotif: false,
      menus: [],
    };
  },

  mounted() {
    this.initNotifications();
    this.bindDropdownEvents();
    this.notifInterval = setInterval(() => {
      this.loadNotifications();
    }, 120000);
    this.fetchMenus();
  },

  beforeUnmount() {
    clearTimeout(this.autoCloseTimer);
    clearInterval(this.notifInterval);
    this.unbindDropdownEvents();
  },

  computed: {
    notifications() {
      return this.expiringList;
    },

    /** SPK = Surat Perintah Kerja (bukan PKS/Adendum) */
    totalSpk() {
      return this.expiringList.filter((x) => {
        const t = String(x?.source_type || "")
          .toUpperCase()
          .trim();
        return (
          t.includes("SURAT PERINTAH") ||
          t === "SPK" ||
          (t.includes("SPK") && !t.includes("PKS") && !t.includes("PERJANJIAN"))
        );
      }).length;
    },

    /** PKS + Adendum + DOCUMENT generik (bukan SPK / transport / asset) */
    totalPks() {
      return this.expiringList.filter((x) => {
        const t = String(x?.source_type || "")
          .toUpperCase()
          .trim();
        if (!t) return false;
        if (t === "TRANSPORT_OFFER" || t.includes("PENAWARAN")) return false;
        if (
          t === "ASET_IT" ||
          t === "ASSET" ||
          t === "INFRASTRUCTURE" ||
          t.includes("ASSET") ||
          t.includes("ASET") ||
          t.includes("INFRA")
        )
          return false;
        // SPK → dihitung di totalSpk
        if (
          t.includes("SURAT PERINTAH") ||
          t === "SPK" ||
          (t.includes("SPK") && !t.includes("PKS") && !t.includes("PERJANJIAN"))
        )
          return false;
        return (
          t === "DOCUMENT" ||
          t.includes("PERJANJIAN") ||
          t.includes("PKS") ||
          t.includes("ADENDUM") ||
          t.includes("ADDENDUM")
        );
      }).length;
    },

    /** Kompatibel lama: total semua dokumen perjanjian */
    totalDocument() {
      return this.totalSpk + this.totalPks;
    },
    totalTransportOffer() {
      return this.expiringList.filter((x) => {
        const t = String(x?.source_type || "")
          .toUpperCase()
          .trim();
        return t === "TRANSPORT_OFFER" || t.includes("PENAWARAN");
      }).length;
    },

    totalAsset() {
      return this.expiringList.filter((x) => {
        const t = String(x?.source_type || "")
          .toUpperCase()
          .trim();
        return (
          t === "ASET_IT" ||
          t === "ASSET" ||
          t === "INFRASTRUCTURE" ||
          t.includes("ASET") ||
          t.includes("ASSET") ||
          t.includes("INFRA")
        );
      }).length;
    },

    hasAnyNotification() {
      return this.expiringList.length > 0 || this.evalNotifications.length > 0;
    },

    notificationBadgeCount() {
      return this.expiringList.length + this.evalNotifications.length;
    },

    profilePhoto() {
      const user = this.userLogin;
      if (!user?.mst_employee_id || !user?.mst_employee_photo) {
        return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' fill='%23ffffff' viewBox='0 0 16 16'%3E%3Cpath d='M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z'/%3E%3Cpath fill-rule='evenodd' d='M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z'/%3E%3C/svg%3E";
      }
      return `https://s3.ap-southeast-1.amazonaws.com/cache.fli.id/prod/sso_profile_img/profile/${user.mst_employee_id}/${user.mst_employee_photo}`;
    },
    isAdmin() {
      return (
        Number(this.userLogin?.group_id) === 1 ||
        (this.userLogin?.group_name || "").toLowerCase().includes("admin")
      );
    },
    userDivisionId() {
      return this.userLogin?.mst_division_id != null
        ? Number(this.userLogin.mst_division_id)
        : null;
    },
    canViewDocument() {
      return this.isAdmin || [3, 4, 6].includes(this.userDivisionId);
    },
    canViewOffer() {
      return this.isAdmin || [3, 4, 6].includes(this.userDivisionId);
    },
    canViewAsset() {
      return this.isAdmin || this.userDivisionId === 7;
    },
  },

  methods: {
    onAvatarError(e) {
      e.target.src =
        "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' fill='%23ffffff' viewBox='0 0 16 16'%3E%3Cpath d='M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z'/%3E%3Cpath fill-rule='evenodd' d='M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z'/%3E%3C/svg%3E";
    },

    async loadNotifications() {
      if (this.isLoadingNotif) return;
      this.isLoadingNotif = true;

      try {
        // 1) H-60
        try {
          const res = await dashboardService.getSummary();
          this.expiringList = res?.expiringList || [];
        } catch (error) {
          console.warn("Gagal H-60:", error?.message || error);
        }

        // 2) Notifikasi dari tabel t107 (APPROVED / REJECTED / PENDING)
        let fromTable = [];
        try {
          const res = await notificationService.getMyNotifications({
            // tampilkan semua yang belum dibaca + tetap tampilkan EVAL_PENDING
            unread_only: 0,
            limit: 50,
          });
          const payload = res?.data?.data || {};
          fromTable = payload.list || [];
          this.unreadEvalCount = payload.unreadCount || 0;
        } catch (error) {
          console.warn("Gagal notif tabel:", error?.message || error);
        }

        // 3) Pending approval real-time (sumber kebenaran untuk Manager)
        let fromPending = [];
        try {
          const res = await vendorEvaluationService.getPendingApproval();
          const list = res?.data?.data || res?.data || [];
          const arr = Array.isArray(list) ? list : [];
          fromPending = arr.map((p) => ({
            id: `pending-${p.approval_id || p.evaluation_id}`,
            type: "EVAL_PENDING",
            title: "Menunggu approval",
            message: `${p.penilai_name || "Staff"} · ${
              p.nama_supplier || "Vendor"
            }`,
            reference_type: "VENDOR_EVALUATION",
            reference_id: p.evaluation_id,
            is_read: 0,
            created_on: p.submitted_on || null,
            _fromPendingApi: true,
          }));
        } catch (error) {
          // user bukan approver → 200 kosong / error, abaikan
          console.warn("Gagal pending approval:", error?.message || error);
        }

        // EVAL_PENDING: HANYA dari pending-approval API (sumber kebenaran)
        // Jangan pakai EVAL_PENDING dari t107 — bisa stale setelah approve/reject
        const tableFiltered = fromTable.filter((n) => {
          if (n.type === "EVAL_PENDING") return false;
          // APPROVED/REJECTED yang sudah dibaca disembunyikan
          if (
            (n.type === "EVAL_APPROVED" || n.type === "EVAL_REJECTED") &&
            Number(n.is_read) === 1
          ) {
            return false;
          }
          return true;
        });

        this.evalNotifications = [...fromPending, ...tableFiltered];
      } finally {
        this.isLoadingNotif = false;
      }
    },

    async initNotifications() {
      await this.loadNotifications();
      const alreadyShown = sessionStorage.getItem("notifShown");
      if (this.hasAnyNotification && !alreadyShown) {
        this.dropdownInstance = Dropdown.getOrCreateInstance(
          this.$refs.notifButton,
        );
        this.dropdownInstance.show();
        sessionStorage.setItem("notifShown", "true");
      }
    },

    bindDropdownEvents() {
      const el = this.$refs.notifButton;
      if (!el) return;
      el.addEventListener("show.bs.dropdown", this.onDropdownShow);
      el.addEventListener("hidden.bs.dropdown", this.onDropdownHidden);
    },

    unbindDropdownEvents() {
      const el = this.$refs.notifButton;
      if (!el) return;
      el.removeEventListener("show.bs.dropdown", this.onDropdownShow);
      el.removeEventListener("hidden.bs.dropdown", this.onDropdownHidden);
    },

    onDropdownShow() {
      this.showBackdrop = true;
      clearTimeout(this.autoCloseTimer);
      this.autoCloseTimer = setTimeout(() => this.closeNotifDropdown(), 10000);
    },

    onDropdownHidden() {
      this.showBackdrop = false;
      clearTimeout(this.autoCloseTimer);
    },

    closeNotifDropdown() {
      const el = this.$refs.notifButton;
      const instance = Dropdown.getInstance(el);
      if (instance) instance.hide();
    },

    onBackdropClick() {
      this.closeNotifDropdown();
    },

    async openEvalNotification(item) {
      // Mark read hanya untuk row di t107 (bukan virtual pending)
      if (
        item.id &&
        !item._fromPendingApi &&
        !String(item.id).startsWith("pending-")
      ) {
        try {
          await notificationService.markAsRead(item.id);
          item.is_read = 1;
        } catch (e) {
          console.warn(e);
        }
      }

      this.closeNotifDropdown();

      if (item.reference_id) {
        this.$router.push({
          path: "/vendor-evaluation",
          query: {
            evaluationId: item.reference_id,
            mode: "view",
          },
        });
      }
    },

    evalIcon(type) {
      if (type === "EVAL_PENDING") return "bi bi-hourglass-split text-warning";
      if (type === "EVAL_APPROVED")
        return "bi bi-check-circle-fill text-success";
      if (type === "EVAL_REJECTED") return "bi bi-x-circle-fill text-danger";
      return "bi bi-bell text-primary";
    },

    formatNotifTime(dt) {
      if (!dt) return "";
      try {
        return new Intl.DateTimeFormat("id-ID", {
          day: "2-digit",
          month: "short",
          hour: "2-digit",
          minute: "2-digit",
        }).format(new Date(dt));
      } catch {
        return "";
      }
    },

    goDetail() {
      this.closeNotifDropdown();
      this.$router.push("/report/report-expiring");
    },

    fetchMenus() {
      api
        .get("/menu/by-group-id")
        .then(({ data }) => {
          this.menus = data.data;
        })
        .catch((error) => {
          console.error("Gagal mengambil daftar menu:", error);
          this.menus = [];
        });
    },

    goToMenu(url) {
      if (!url) return;
      window.location.href = url;
    },

    logout() {
      performLogout();
    },
  },
};
